import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ToastAlert = ({ msgType = "default", msg = "", toastId = null }) => {
  const settings = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    toastId: toastId || msg,
  };

  switch (msgType.toLowerCase()) {
    case "success":
      toast.success(msg, settings);
      break;
    case "error":
      toast.error(msg, settings);
      break;
    case "warning":
      toast.warn(msg, settings);
      break;
    case "info":
      toast.info(msg, settings);
      break;
    default:
      toast(msg, settings);
  }
};

export default ToastAlert;
